import { Component, inject, Input } from '@angular/core';
import { OrderCompleteInstructionsFemaleCondomComponent } from '@components/order-complete/order-complete-instructions/order-complete-instructions-female-condom/order-complete-instructions-female-condom.component';
import { OrderCompleteInstructionsHealthlabsComponent } from '@components/order-complete/order-complete-instructions/order-complete-instructions-healthlabs/order-complete-instructions-healthlabs.component';
import { OrderCompleteInstructionsStallionComponent } from '@components/order-complete/order-complete-instructions/order-complete-instructions-stallion/order-complete-instructions-stallion.component';
import { OrderCompleteInstructionsStarfishComponent } from '@components/order-complete/order-complete-instructions/order-complete-instructions-starfish/order-complete-instructions-starfish.component';
import { OrderCompleteInstructionsStdcheckComponent } from '@components/order-complete/order-complete-instructions/order-complete-instructions-stdcheck/order-complete-instructions-stdcheck.component';
import { OrderCompleteInstructionsTestosteroneHqComponent } from '@components/order-complete/order-complete-instructions/order-complete-instructions-testosterone-hq/order-complete-instructions-testosterone-hq.component';
import { OrderCompleteInstructionsTreatmyutiComponent } from '@components/order-complete/order-complete-instructions/order-complete-instructions-treatmyuti/order-complete-instructions-treatmyuti.component';
import { OrderCompleteIntakeLinkComponent } from '@components/order-complete/order-complete-intake-link/order-complete-intake-link.component';
import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { Sites } from '@enums/sites';
import { environment } from '@environments/environment';
import { OrderCompleteDetails } from '@models/order-complete-details';
import { ConsultationRequestService } from '@services/consultation-request.service';
import { StorageService } from '@services/storage.service';

@Component({
  selector: 'app-order-complete-instructions',
  templateUrl: './order-complete-instructions.component.html',
  imports: [
    OrderCompleteInstructionsFemaleCondomComponent,
    OrderCompleteInstructionsStdcheckComponent,
    OrderCompleteInstructionsHealthlabsComponent,
    OrderCompleteInstructionsTreatmyutiComponent,
    OrderCompleteInstructionsStarfishComponent,
    OrderCompleteInstructionsStallionComponent,
    OrderCompleteInstructionsTestosteroneHqComponent,
    OrderCompleteIntakeLinkComponent,
  ],
})
export class OrderCompleteInstructionsComponent {
  @Input() public orderCompleteDetails: OrderCompleteDetails;
  @Input() public treatmentType: ConsultationTreatmentTypes;
  public Sites: typeof Sites = Sites;

  private readonly storage = inject(StorageService);
  private readonly consultationRequestService = inject(ConsultationRequestService);

  public get site(): Sites {
    return environment.site as Sites;
  }

  public get isFemaleCondom(): boolean {
    return this.treatmentType === ConsultationTreatmentTypes.FemaleCondom;
  }

  /**
   * Determines if the patient intake link section should be displayed.
   */
  public get showPatientIntakeSection(): boolean {
    return !!this.storage.baOrder?.isActive && !!this.treatmentType;
  }

  /**
   * Builds the absolute URL for the patient's intake/questionnaire page.
   *
   * @returns {string} the URL for the patient's questionnaire page
   */
  public get intakeUrl(): string {
    return this.consultationRequestService.getConsultationPageUrl(
      this.treatmentType,
      this.orderCompleteDetails.transactionId,
      this.orderCompleteDetails.hash,
    );
  }
}
